import { pdpTradeOnboardingRule } from '../../../global/tradeOnboarding/tradeOnboardingRules';

import { PRIORITIES, SHOW_PDP_TRADE_ONBOARDING } from '../pdpSharedNotificationConstants';

export const config = {
    name: 'pdpTradeOnboardingModal',
    priority: PRIORITIES.PDP_SOURCING_MODAL,
    rule: pdpTradeOnboardingRule,
    action: () => dispatch =>
        dispatch({
            type: SHOW_PDP_TRADE_ONBOARDING,
        }),
};
